var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "lexon-colorpicker-container" },
    [
      _c(
        "ejs-colorpicker",
        _vm._b(
          {
            attrs: {
              mode: "Palette",
              id: "color-picker",
              name: "color-picker",
              "default-value": _vm.defaultValue,
              cssClass: "lexon-colorpicker-popup",
            },
            model: {
              value: _setup.color,
              callback: function ($$v) {
                _setup.color = $$v
              },
              expression: "color",
            },
          },
          "ejs-colorpicker",
          _vm.$attrs,
          false
        )
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }